import { Directive, OnInit, ViewChild} from '@angular/core';
import {Injector} from "@angular/core";
import {NgForm} from "@angular/forms";
import {MessageService} from "primeng/api";
import {ConfirmationService} from "primeng/api";

@Directive()
export abstract class BaseFormComponentComponent implements OnInit {

  constructor(protected injector: Injector) { }

  @ViewChild(NgForm) form: NgForm;

  isLoading: boolean = false;

  showMessage(severity: string, summary: string, detail: string) {
    this.injector.get(MessageService).add({severity, summary, detail});
  }

  confirm(message: string = null) {
   return new Promise((resolve, reject) => {
      this.injector.get(ConfirmationService).confirm({
        message: message || 'İşleme devam etmek istediğinize emin misiniz ?',
        accept: () =>  resolve(true),
        reject: () => reject()
      })
    })

  }

  ngOnInit(): void {  }

  isValid() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }

    if(invalid.length > 0) {
      // Todo çeviri ekle.
      this.injector.get(MessageService).add({severity: 'error', summary: 'Hata', detail: `${invalid[0]} zorunlu alandır.`});
    }
    return invalid.length == 0
  }

}
